module.exports = __webpack_public_path__ + "static/media/whatsapp-icon.29dc3be7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/whatsapp-icon.png
// module id = 2075
// module chunks = 0